'use client'

import {useEffect} from "react";
import {useSearchParams} from "next/navigation";

const PartnerTrack = () => {
    const searchParams = useSearchParams()
    const partner = searchParams.get('partner')
    const utm_source = searchParams.get('utm_source')
    const utm_campain = searchParams.get('utm_campain')

    useEffect(() => {
        if (partner || utm_source) {
            localStorage.setItem('partner', partner || utm_source as string)
        } else if (utm_campain) {
            const campaign = 'finmart' || utm_campain as string
            localStorage.setItem('partner', campaign)
        }
    }, [])

    return (
        <>

        </>
    )
}

export default PartnerTrack